import React from 'react';
import TypeAhead from './typeahead';
import { typeahead_firm } from '../../../ducks/Shared';

const FirmTypeAhead = function ({ officeType = 'brokerage', ...props }) {
  return (
    <TypeAhead
      {...props}
      labelAsValue
      loadOptions={(search, callback) => {
        return typeahead_firm(
          {
            search,
            officeType
          },
          callback
        );
      }}
    />
  );
};

export default FirmTypeAhead;



// WEBPACK FOOTER //
// ./src/components/form/field/firm-typeahead.js